import React from "react";
import EditIcon from "@/components/SVGComponents/EditIcon";
import DeleteIcon from "@/components/SVGComponents/DeleteIcon";
import styles from "./ActionsCell.module.scss";
import Tooltip from "../Tooltip/Tooltip";
import TickIcon from "../SVGComponents/TickIcon";
import CrossIcon from "../SVGComponents/CrossIcon";

interface ActionsCellProps {
  id?: string | number;
  image?: string | null;
  onView?: (() => void) | undefined;
  onText?: (() => void) | undefined;
  onApprove?: (() => void) | undefined;
  onReject?: (() => void) | undefined;
  onEdit?: () => void;
  onDelete?: () => void;
}

const ActionsCell: React.FC<ActionsCellProps> = ({
  id = "0",
  image,
  onView,
  onEdit,
  onDelete,
  onText,
  onApprove,
  onReject,
}) => {
  return (
    <div className={styles.actions}>
      {onApprove && (
        <Tooltip id={id} data="Approve">
          <TickIcon className={styles.approveIcon} onClick={onApprove} />
        </Tooltip>
      )}
      {onReject && (
        <Tooltip id={id} data="Reject">
          <CrossIcon className={styles.rejectIcon} onClick={onReject} />
        </Tooltip>
      )}
      {onEdit && (
        <Tooltip id={id} data="Edit">
          <EditIcon className={styles.editIcon} onClick={onEdit} />
        </Tooltip>
      )}
      {onDelete && (
        <Tooltip id={id} data="Delete">
          <DeleteIcon className={styles.deleteIcon} onClick={onDelete} />
        </Tooltip>
      )}
      {onText && (
        <button className={styles.viewText} onClick={onText}>
          {" "}
          View Offers
        </button>
      )}
    </div>
  );
};

export default ActionsCell;
